import { useEffect, useState } from "react";
import type { User } from "@board/shared";
import { api, ApiError } from "./api";
import { SignIn } from "./SignIn";
import { BoardApp } from "./BoardApp";

type State = { status: "loading" } | { status: "out" } | { status: "in"; user: User };

export function App() {
  const [state, setState] = useState<State>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    api
      .me()
      .then(({ user }) => {
        if (!cancelled) setState({ status: "in", user });
      })
      .catch((error) => {
        if (cancelled) return;
        if (error instanceof ApiError && error.status === 401) setState({ status: "out" });
        else setState({ status: "out" });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state.status === "loading") return null;
  if (state.status === "out") return <SignIn />;

  return <BoardApp user={state.user} />;
}
